import { useMutation, useQueryClient } from "react-query";
import { shop } from "@/repositories/shop";
import { Shop } from "@/types/v2";
import { useOnShopUpdate } from "@/hooks/queries/usePaginatedShops";

export const useUpdateShopMutation = () => {
  const queryClient = useQueryClient();
  const onShopUpdate = useOnShopUpdate();

  return useMutation(
    ({ shopId, shopData }: { shopId: string; shopData: Partial<Shop> }) =>
      shop.update(shopId, shopData),
    {
      onSuccess: (_, { shopId, shopData }) => {
        // Invalidate and refetch the shop query
        // Update the specific shop query cache immediately
        queryClient.setQueryData<Shop | undefined>(
          ["shops", shopId],
          (oldData: Shop | undefined) => {
            if (!oldData) return undefined;
            return { ...oldData, ...shopData };
          }
        );

        onShopUpdate(shopId, shopData);
      },
    }
  );
};
